import { render, staticRenderFns } from "./DisclosureDocuments.vue?vue&type=template&id=357679f0&scoped=true&"
import script from "./DisclosureDocuments.vue?vue&type=script&lang=ts&"
export * from "./DisclosureDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureDocuments.vue?vue&type=style&index=0&id=357679f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357679f0",
  null
  
)

export default component.exports